import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './i18n';
import './styles/globals.css';

// Recover from stale chunk references after a new deployment: reload once when
// a lazy-loaded module fails to fetch (guarded against reload loops).
window.addEventListener('vite:preloadError', () => {
  if (!sessionStorage.getItem('sm_chunk_reload')) {
    sessionStorage.setItem('sm_chunk_reload', '1');
    window.location.reload();
  }
});

const rootElement = document.getElementById('root');

if (!rootElement) {
  throw new Error('Root element not found. Ensure index.html contains a <div id="root"></div>.');
}

ReactDOM.createRoot(rootElement).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
